
import type {
  ListProgramSessionsVars, ProgramFilter,
} from "@/plugins/api/modules/program"
import programDays from "@/mixins/program-days"
import { LANDING_PROGRAM_FILTERS } from "@/utils/program"
import breakpoints from "@/assets/style/_breakpoints.scss"

const DESKTOP_PAGE_LIMIT = 12
const MOBILE_PAGE_LIMIT = 6

export default programDays.extend({
  layoutSettings: {
    titleToken: "program",
  },

  data: () => ({
    lazyDictionaries: true,
    pageLimit: DESKTOP_PAGE_LIMIT,
  }),

  async fetch () {
    await this.fetchProgram()
  },

  computed: {
    tabFilters (): ProgramFilter[] {
      return LANDING_PROGRAM_FILTERS
    },
  },

  mounted () {
    if (window.innerWidth > Number(breakpoints.xs)) return

    this.pageLimit = MOBILE_PAGE_LIMIT
    this.fetchSessions()
  },

  methods: {
    listSessions (variables: ListProgramSessionsVars) {
      return this.$api.program.listLandingProgramSessions(
        variables, this.programApiConfig,
      )
    },

    goToSession (id: string) {
      this.$router.push(this.localePath(`/events/mfm2026/program/${id}`))
    },
  },
})
